import React from 'react';

const Header = () => {
  return (
    <header className="w-full bg-blue-700 text-white p-4 flex justify-between items-center">
      <div className="flex items-center">
        <svg className="w-8 h-8 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
        </svg>
        <h1 className="text-xl font-bold">Sistema de Diagnóstico de Causa Raiz</h1>
      </div>
      <div className="flex items-center">
        <div className="mr-4">
          <span className="mr-2">Carlos Andrade</span>
          <span className="bg-blue-800 px-2 py-1 rounded text-xs">Analista de Qualidade</span>
        </div>
        <div className="w-8 h-8 bg-blue-800 rounded-full flex items-center justify-center">
          <span className="font-bold">CA</span>
        </div>
      </div>
    </header>
  );
};

export default Header;